import React from 'react'
import { Text, Button, Icon, A } from '@rebrandly/styleguide'

import SignUpButton from '../SignUpButton'
import FreeTrialButton from '../FreeTrialButton'

import './PricingBanner.css'
import { bool } from 'prop-types'

const PricingBanner = ({ isQr }) => {
  return (
    <div className='PricingBanner'>
      <div className='container p-b-24'>
        <div className='PricingBanner__container'>
          <div className='PricingBanner__text-container'>
            <Text size='3x-large' className='m-b-24'>Take your business to the next level!</Text>
            <div className='PricingBanner__large-screen'>
              <Text size='regular' className='m-b-24'>Want to shorten links, brand them, create custom QR codes, and
                access detailed analytics? </Text>
              <Text size='regular'>Get Rebrandly for your business and supercharge your link management. </Text>
            </div>
            <div className='PricingBanner__small-screen'>
              <Text size='regular'>Want to shorten links, brand them, create custom QR codes, and
                access detailed analytics? Get Rebrandly for your business and supercharge your link management. </Text>
            </div>
          </div>
          <div className='PricingBanner__carts-container'>
            <div className='PricingBanner__cart border border-smoke-600 radius-12'>
              <div className='PricingBanner__cart-header bg-smoke-100 p-b-64'>
                <Text size='large' className='m-b-24'>Free</Text>
                <Text size='3x-large' className='m-b-24'>$0</Text>
                <SignUpButton className='full-width' isQr={isQr}><Button theme='primary' size='x-lg' className='full-width'><span className='font-bold'>Sign up for free</span></Button></SignUpButton>
              </div>
              <div className='PricingBanner__card-limits'>
                <div className='PricingBanner__card-limit-row bg-yellow-400'>
                  <Icon color='var(--color-black)' name='ic-link' size='regular'/>
                  <Text size='small' className='m-l-8'>
                    <span className='font-bold'>10</span> Links/Mo
                  </Text>
                </div>
                <div className='PricingBanner__card-limit-row'>
                  <Icon color='var(--color-black)' name='ic-qrcode' size='regular'/>
                  <Text size='small' className='m-l-8'>
                    <span className='font-bold'>10</span> QR Codes/Mo
                  </Text>
                </div>
                <div className='PricingBanner__card-limit-row'>
                  <Icon color='var(--color-black)' name='ic-domain-heart' size='regular'/>
                  <Text size='small' className=' m-l-8'>
                    <span className='font-bold'>1</span>  Custom Domains
                  </Text>
                </div>
              </div>
            </div>

            <div className='PricingBanner__cart border border-smoke-600 radius-12'>
              <div className='PricingBanner__cart-header bg-blue-100'>
                <Text size='large' className='m-b-24'>Essentials</Text>
                <Text size='3x-large' className='m-b-24'>$13/mo</Text>
                <A href='https://rebrandly.sale/premium'  target='_blank' className='full-width'><Button theme='secondary' size='x-lg' className='full-width m-b-16' ><span className='font-bold'>Buy now</span></Button></A>
                <FreeTrialButton isQr={isQr}><Text className='font-bold' size='medium'>Start free trial</Text></FreeTrialButton>
              </div>
              <div className='PricingBanner__card-limits'>
                <div className='PricingBanner__card-limit-row bg-yellow-400'>
                  <Icon color='var(--color-black)' name='ic-link' size='regular'/>
                  <Text size='small' className='m-l-8'>
                    <span className='font-bold'>250</span> Links/Mo
                  </Text>
                </div>
                <div className='PricingBanner__card-limit-row'>
                  <Icon color='var(--color-black)' name='ic-qrcode' size='regular'/>
                  <Text size='small' className='m-l-8'>
                    <span className='font-bold'>250</span> QR Codes/Mo
                  </Text>
                </div>
                <div className='PricingBanner__card-limit-row'>
                  <Icon color='var(--color-black)' name='ic-domain-heart' size='regular'/>
                  <Text size='small' className=' m-l-8'>
                    <span className='font-bold'>2</span> Custom Domains
                  </Text>
                </div>
                <div className='PricingBanner__card-limit-row'>
                  <Icon color='var(--color-black)' name='ic-checkmark' size='regular'/>
                  <Text size='small' className='m-l-8'>
                    <span className='font-bold'>10</span>  Link Destination Edits/Mo
                </Text>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

PricingBanner.prototype = {
  isQr: bool
}
export default PricingBanner
